import Subnav from 'global/subnav';
import { GLOBALS } from 'constants/settings';

class Creators {
  constructor(elems) {
    this.elems = elems;

    this.elems.creators = {
      $nav      : document.getElementById('creators-navigation'),
      $letters  : [].slice.call(document.getElementsByClassName('creators-mobile-subnav-option')),
      $name     : document.getElementById('creator-name'),
      $results  : document.getElementById('creator-results'),
      $creators : [].slice.call(document.getElementsByClassName('creators-list-entry'))
    };

    this.elems.creators.$letters.map(($letter, i) => {
      $letter.addEventListener('click', (e) => {
        $('html, body').animate({
          scrollTop: this.elems.creators.$nav.offsetTop - 100
        }, GLOBALS.transition * 2);
      });
    });

    this.elems.creators.$creators.map(($creator, i) => {
      $creator.addEventListener('click', (e) => {
        $('.creators-list-entry').removeClass('active');
        $creator.classList.add('active');
        this.elems.creators.$name.innerHTML = e.target.innerHTML;
        window.history.pushState(null, null, e.target.getAttribute('href'));
      });
    });

    this.Subnav       = new Subnav('creators', this.elems);
    this.MobileSubnav = new Subnav('creators-mobile', this.elems);
  }
}

export default Creators;



// WEBPACK FOOTER //
// ./app/javascript/creators/index.js